import { render, staticRenderFns } from "./IDConvertor.vue?vue&type=template&id=ce794776&"
import script from "./IDConvertor.vue?vue&type=script&lang=js&"
export * from "./IDConvertor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports